export enum MapActionsNotificacao {
    NOME_MODULO = 'notificacao',
    ATUALIZAR_NOTIFICACOES = 'atualizarNotificacoes',
}

export class MapActionsNotificacaoModule {
    static ATUALIZAR_NOTIFICACOES = `${MapActionsNotificacao.NOME_MODULO}/${MapActionsNotificacao.ATUALIZAR_NOTIFICACOES}`;
}
